import React from "react";

const SearchBox = ({ value, onChange }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Escape") onChange("");
  };

  return (
    <div className="search-field my-3">
      <i className="fa fa-search search-icon" aria-hidden="true" />
      <input
        type="search"
        name="query"
        placeholder="Search..."
        value={value}
        onChange={e => onChange(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
      />
      {value ? (
        <button
          type="button"
          className="search-clear"
          onClick={() => onChange("")}
          aria-label="Clear search"
        >
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/searchBox.jsx